import Vue from 'vue'
import Router from 'vue-router'

import app from '@/routes/app'
// import map from '@/routes/map'

Vue.use(Router)

export default () => {
  return new Router({
    routes: [
      app
    ]
    // mode: 'history'
  })
}



// WEBPACK FOOTER //
// ./src/routes/index.js